// extracted by mini-css-extract-plugin
export var close = "search-header-module--close--1cc55";
export var container = "search-header-module--container--cc930";
export var contentContainer = "search-header-module--content-container--7141a";
export var inputFieldDiv = "search-header-module--input-field-div--2c831";
export var searchLink = "search-header-module--search-link--866a1";
export var searchResults = "search-header-module--search-results--e55f9";
export var viewMore = "search-header-module--view-more--0301a";